const ClientSignature = () => import('../view/Signature.vue')

export default [
   {
      path: 'signature',
      name: 'signature',
      component: ClientSignature
   }
]
